<template>
  <div class="container">
    <div class="group">
      <h1 class="page-title has-text-centered">
        CREATE NEW PASSWORD
      </h1>
      <p class="lead">Enter your new password below</p>
      <form @submit.prevent="changePassword">
        <div class="field">
          <label class="label">Password</label>
          <div class="control">
            <input v-model="password" class="input" type="password" />
          </div>
        </div>
        <div class="field">
          <label class="label">Re-Enter Password</label>
          <div class="control">
            <input v-model="confirmPassword" class="input" type="password" />
          </div>
        </div>
        <div v-show="message" class="help is-danger">{{ message }}</div>
        <button class="button is-fullwidth" type="submit">
          Continue
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
      message: ''
    };
  },
  mounted() {
    if (this.$route.query.token == undefined || this.$route.query == '') {
      this.$router.replace({ name: 'login' });
    }
  },
  methods: {
    changePassword() {
      this.axiosRequest('put', 'Auth/ForgotPassword', {
        token: this.$route.query.token,
        newPassword: this.password,
        confirmPassword: this.confirmPassword
      })
        .then(() => {
          // console.log(response.data);
          this.$router.replace({ name: 'login' });
        })
        .catch(error => {
          if (error.response.status === 400) {
            console.error(error.response.data);
            this.message = error.response.data.errors
              .map(e => e.message)
              .join();
          }
        });
    }
  }
};
</script>

<style lang="scss">
.page-reset-password {
  .field {
    margin: 3rem 0;
  }
  .help {
    margin-bottom: 3rem;
  }
}
</style>
